import React, { Component } from "react";
import { Container, Grid, Header, Image, Segment, Divider, Icon } from "semantic-ui-react";
import logo from "../assets/img/bump-ticketlogo.png";
import axios from "axios";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch = (error, errorInfo) => {
    this.setState(
      {
        error: error,
        errorInfo: errorInfo
      },
      this.logMessage
    );
  };

  logMessage = () => {
    const path = this.props.history.location.pathname;
    const { error, errorInfo } = this.state;
    let msg = `*${error.message}* from ${path}`;
    msg += "\n";
    msg += "```";
    msg += errorInfo.componentStack;
    msg += "```";

    const endpoint = process.env.REACT_APP_SLACK_WEBHOOK;
    if (endpoint === false) return false; 
    const message = {
      text: msg
    };
    const payload = JSON.stringify(message);

    axios.post(endpoint, payload).then(resp => {
      return resp;
    });
  };

  render() {
    if (this.state.errorInfo) {
      return (
        <Container fluid id="wrapper" className="login">
          <Grid verticalAlign="middle" textAlign="center" padded>
            <Grid.Column mobile={16} tablet={12} computer={6}>
              <Segment>
                <Image src={logo} size="small" centered />
                <Header as="h1">Oops!</Header>
                <Header>Something went wrong</Header>
                <p className="errorBumpCBNsupport">
                  <p>Please try again later, if the problem persists please reach us via:</p>
                  <span><Icon name="envelope"/><a href="mailto:cgsupport@cbnco.com">cgsupport@cbnco.com</a></span>
                  <Divider horizontal>OR</Divider>
                  <span><Icon name="phone"/>1-800-815-0867 (Option 1)</span>
                </p>
                <details style={{ whiteSpace: "pre-wrap" }}>
                  {this.state.error && this.state.error.toString()}
                  <br />
                  {this.state.errorInfo.componentStack}
                </details>
              </Segment>
            </Grid.Column>
          </Grid>
        </Container>
      );
    }
    // Render children if there's no error
    return this.props.children;
  }
}

export default ErrorBoundary;
